import {
  CLEAR_COST,
  SAVE_COST,
  SAVE_REFUND_WAY,
  GET_REFUND_WAY,
  GET_NAME_PHONE,
  GET_INSURANCEC_CHANGE,
} from './actions';

const initialState = {
  cost: [], // 退票费用
  refundWay: 0, // 0 原流水退款，1 极速退款
  showRefundWay: false, // 是否展示退款方式
  contactInfo: {
    contact: '',
    contactPhone: '',
    encContact: '',
    encContactPhone: '',
    areaCode: '86',
  },
  referral: '', //推荐码
  insuranceList: [],
};

export default function ReformProcessReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_COST:
      return Object.assign({}, state, {
        cost: [],
        refundWay: 0,
      });
    case SAVE_COST:
      return Object.assign({}, state, { cost: action.data.refundRepayInfos });
    case `${GET_REFUND_WAY}_SUCCESS`: {
      const {
        payload: { data },
      } = action;

      // if (data.refundModeRes.existRefundMode) {
      //   return Object.assign({}, state, {
      //     refundWay: 0,
      //     showRefundWay: false,
      //   });
      // }

      return Object.assign({}, state, {
        refundWay: data.refundModeRes.refundMode === '2' ? 1 : 0,
        showRefundWay: data.refundModeRes.existRefundMode,
      });
    }
    case SAVE_REFUND_WAY:
      return Object.assign({}, state, {
        refundWay: action.data,
      });
    case `${GET_NAME_PHONE}_SUCCESS`: {
      const {
        payload: { data },
      } = action;
      const contactInfo = {
        contact: data.nameAndPhoneRes.name || '',
        contactPhone: data.nameAndPhoneRes.telphone || '',
        // contactPhone: data.nameAndPhoneRes.telphone,
        encContact: data.nameAndPhoneRes.encriptName || '',
        encContactPhone: data.nameAndPhoneRes.encriptTel || '',
        areaCode: data.nameAndPhoneRes.areaCode || '86',
      };
      return Object.assign({}, state, { contactInfo });
    }

    // case MU_CONTACT_INFO:
    //   return Object.assign({}, state, {
    //     contactInfo,
    //   });
    // case `${GET_INSURANCEC_CHANGE}_SUCCESS`: {
    //   const {
    //     payload: { data },
    //   } = action;
    //   console.log(state);
    //   return Object.assign({}, state, { insuranceList: data });
    // }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/applySubmit/modules/applySubmit.js